import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { images } from '../../data/images';
import { livingQuickLinks } from '../../data/navigation';
export function LivingHero() {
  return <section className="relative" data-id="element-360" data-mp="jplzhnmvyxdd">
      <div className="h-[380px] overflow-hidden sm:h-[500px] lg:h-[620px]" data-id="element-361" data-mp="on5nvgdasqj1">
        <img src={images.livingHero} alt="Riad-binnenplaats met een gedekte tafel: Safi-borden, beldi theeglazen, een zilveren theepot en een koperen lantaarn" className="h-full w-full object-cover" data-id="element-362" data-mp="op8arrj5m3jj" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 lg:absolute lg:inset-x-0 lg:top-24 lg:px-8" data-id="element-363" data-mp="12noqg7yzv4dt">
        <div className="-mt-24 max-w-lg rounded-2xl bg-white p-7 shadow-[0_24px_60px_-28px_rgba(20,20,20,0.45)] sm:p-9 lg:mt-0" data-id="element-364" data-mp="17l83x5nvbd4p">
          <h1 className="text-[2rem] font-semibold leading-[1.05] tracking-tight text-ink sm:text-[2.6rem]" data-id="element-365" data-mp="1va1115g87r0w">
            Het Marokkaanse huis, bij jou aan tafel
          </h1>
          <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-366" data-mp="2m098hu7x2faw">
            Handgemaakte sieraden, beschilderd servies en beldi-theeglazen uit Marokko. Vóór 22:00 besteld, morgen in huis.
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-367" data-mp="2vpssj37d8f7c">
            <Link to="/living/collectie/servies" className="inline-flex h-12 items-center whitespace-nowrap rounded-lg bg-terracotta px-6 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-terracotta-dark" data-id="element-368" data-mp="2qy100n4nfzek">
              Shop servies
            </Link>
            <Link to="/living/collectie/alles" className="whitespace-nowrap text-[15px] font-semibold text-majorelle underline underline-offset-4" data-id="element-369" data-mp="3emkb1af32qac">
              Alle producten
            </Link>
          </div>
        </div>
      </div>

      <ul className="relative z-10 mx-auto mt-6 grid max-w-6xl gap-3 px-5 md:grid-cols-3 lg:-mt-14 lg:gap-4 lg:px-8" data-id="element-370" data-mp="1kbp226zzl971">
        {livingQuickLinks.map(({
        to,
        title,
        text,
        icon: Icon
      }) => <li key={to} data-id="element-371" data-mp="250zp1aucvmni">
            <Link to={to} className="group flex h-full items-center gap-4 rounded-xl border border-line bg-white p-4 shadow-[0_12px_32px_-20px_rgba(20,20,20,0.35)] transition-[border-color] duration-150 hover:border-terracotta" data-id="element-372" data-mp="290i5nuf59bkj">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-lg bg-terracotta text-white" data-id="element-373" data-mp="2iwl9d4pn9i9l">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-374" data-mp="2nvy5yh6bi3pd" />
              </span>
              <span className="flex-1" data-id="element-375" data-mp="2rxjclks9dlr4">
                <span className="block font-semibold text-ink" data-id="element-376" data-mp="2wpknp3dox6fk">{title}</span>
                <span className="block text-sm text-muted" data-id="element-377" data-mp="2wsfb93s037d7">{text}</span>
              </span>
              <ArrowRightIcon className="h-4 w-4 text-ink transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-378" data-mp="31r09wyrltizj" />
            </Link>
          </li>)}
      </ul>

      <div className="mt-8 flex justify-center px-5" data-id="element-379" data-mp="3bl921lcq39x6">
        <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 rounded-full border border-line bg-white px-5 py-2.5 text-sm shadow-[0_8px_24px_-16px_rgba(20,20,20,0.3)]" data-id="element-380" data-mp="1011elq4q4pq4">
          <span className="text-lg font-bold text-ink" data-id="element-381" data-mp="q10u40v4c3kc">4,8</span>
          <span className="flex" aria-label="4,8 van 5 sterren" data-id="element-382" data-mp="l2qwljlx8qvk">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#F5A623] text-[#F5A623]" strokeWidth={0} aria-hidden="true" data-id="element-383" data-mp="1ir0yzzpmdgn7" data-mpi={i} />)}
          </span>
          <span className="font-medium text-ink" data-id="element-384" data-mp="1ds6ij4f4k469">3.100+ beoordelingen</span>
        </p>
      </div>
    </section>;
}